import { useState } from "react";
import styled from "styled-components";
import Icon from "../../../../../components/icon";
import { theme } from "../../../../../helpers/theme";
import { ReactComponent as FormInfo } from "../../../../../assets/icons/form-info.svg";
import { StyledPopover } from "../../../unlogged-dashboard/form-bar/styled-popover";

interface FormFieldInfoProps {
  popoverLabel: string;
  popoverContent: string;
  noPadding?: boolean;
}

const FormFieldInfo = ({
  popoverLabel,
  popoverContent,
  noPadding,
}: FormFieldInfoProps) => {
  const [anchorEl, setAnchorEl] = useState<SVGSVGElement | null>(null);

  const handlePopoverOpen = (
    event: React.MouseEvent<SVGSVGElement, MouseEvent>
  ) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <FormFieldInfoWrapper>
      <StorageSectionInfo> {popoverLabel}</StorageSectionInfo>
      <Icon
        height="43px"
        width="43px"
        noPadding={noPadding ? true : false}
        icon={
          <FormInfo
            onMouseEnter={(e) => handlePopoverOpen(e)}
            onMouseLeave={handlePopoverClose}
            aria-owns={open ? "mouse-over-popover" : undefined}
            aria-haspopup="true"
            style={{ cursor: "pointer" }}
          />
        }
      />
      <StyledPopover
        id="mouse-over-popover"
        sx={{
          pointerEvents: "none",
        }}
        open={open}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        disableRestoreFocus
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <InfoPopoverContentContainer>
          {popoverContent}
        </InfoPopoverContentContainer>
      </StyledPopover>
    </FormFieldInfoWrapper>
  );
};

export default FormFieldInfo;

const FormFieldInfoWrapper = styled.div`
  display: flex;
  margin-left: 2px;
  margin-bottom: 2px;
`;
const StorageSectionInfo = styled.span`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  font-family: ${theme.fonts.interMedium};
  color: ${theme.colors.gray01_secondaryText};
`;
const InfoPopoverContentContainer = styled.div`
  padding: 10px;
  background-color: white;
  font-family: ${theme.fonts.interMedium};
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
`;
